import moment from 'moment';

export function date(dateValue, format = 'd/M/Y') {
  return moment(dateValue).format(format)
}

export function datetime(dateValue, format = 'D/MM/Y HH:mm:ss') {
  return moment(dateValue).format(format)
}

export function getHumanized(dateValue) {
  return date(dateValue, 'ddd, MMM Do');
}

export function add(date, count, intervals) {
  if(date == null) {
    date = moment();
  }
  return moment(date).add(count, intervals);
}


export default {
  date,
  datetime,
  getHumanized,
  add
}



// WEBPACK FOOTER //
// ./src/logic/helpers/DateHelper.js